module.exports = {
    "breadcrumbs": `Navigasjonsstier`
};


//# sourceMappingURL=nb-NO.main.js.map
